export class Item {
    constructor(
    	public userId?: string,
    	public email?: string,
    ) {
    }
}
